import React, { useState } from "react";
import { API_BASE_URL } from "../../../config";

function PostPoolCareListing() {
  const [message, setMessage] = useState("");
  const [confirmAccurate, setConfirmAccurate] = useState(false);



  // ================================
  // BASIC LOCATION
  // ================================
  const [suburb, setSuburb] = useState("");
  const [state, setState] = useState("");
  const [postcode, setPostcode] = useState("");

  // ================================
  // CLIENT OVERVIEW
  // ================================
  const [accessType, setAccessType] = useState("Access Available Anytime");
  const [streetParking, setStreetParking] = useState(false);
  const [petsAtHome, setPetsAtHome] = useState(false);
  const [alarmCodeRequired, setAlarmCodeRequired] = useState(false);

 

// ================================
// POOL DETAILS
// ================================
const [poolType, setPoolType] = useState("");
const [poolSize, setPoolSize] = useState("");
const [poolSurface, setPoolSurface] = useState("");
const [hasSpa, setHasSpa] = useState(false);
const [newClient, setNewClient] = useState(false);
const [longTermClient, setLongTermClient] = useState(false);



  // ================================
  // SERVICE PREFERENCES
  // ================================
  const [serviceDay, setServiceDay] = useState("any");
  const [serviceTime, setServiceTime] = useState("any");
  const [frequency, setFrequency] = useState("weekly");

  // ================================
  // POOL SERVICES / CHEMICALS
  // ================================
  const [services, setServices] = useState({
    waterTesting: true,
    chemicalBalancing: true,
    chlorineSupply: false,
    saltCellCleaning: false,
    vacuuming: true,
    skimming: true,
    brushingWalls: true,
    filterCleaning: false,
    acidWash: false,
    equipmentCheck: true,
  });

  const toggleService = (key) => {
    setServices((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  // ================================
  // PRICING
  // ================================
  const [serviceFee, setServiceFee] = useState("");
  const [salePrice, setSalePrice] = useState("");



  // ================================
  // SUBMIT → STRIPE FIRST (LIKE CLEANING)
  // ================================
  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    try {
      const token = localStorage.getItem("token");
      if (!token) {
        setMessage("❌ You must be logged in");
        return;
      }

      const payload = {
        suburb,
        state,
        postcode,
        accessType,
        streetParking,
        petsAtHome,
        alarmCodeRequired,
        poolType,
        poolSize,
        poolSurface,
        hasSpa,
        serviceDay,
        serviceTime,
        frequency,
        services,
        serviceFee,
        salePrice,
        newClient,
        salePrice,
          // ✅ THIS IS THE IMPORTANT LINE
  disclaimerAccepted: confirmAccurate,
      };

      const res = await fetch(
        `${API_BASE_URL}/api/poolcare/payment/create-listing-fee`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await res.json();

      if (!res.ok) {
  setMessage(data.error || "Failed to start listing flow");
  return;
}

if (data.free) {
  alert("✅ Your pool care listing is now live (free launch)");
  window.location.href = "/my-listings";
  return;
}

if (!data.url) {
  setMessage(data.error || "Failed to start Stripe checkout");
  return;
}

window.location.href = data.url;

     
    } catch (err) {
      console.error("❌ Pool care submit error:", err);
      setMessage("❌ Server error. Please try again.");
    }
  };

  return (
    <div style={container}>
      <h2 style={pageHeader}>Post Pool Care Listing</h2>

      {message && (
        <div style={{ textAlign: "center", fontWeight: 600 }}>{message}</div>
      )}

      <form onSubmit={handleSubmit} style={form}>
        {/* LOCATION */}
        <h3 style={sectionHeader}>Location</h3>
        <input style={input} placeholder="Suburb" value={suburb} onChange={(e) => setSuburb(e.target.value)} required />
        <select
  style={input}
  value={state}
  onChange={(e) => setState(e.target.value)}
  required
>
  <option value="">Select State</option>
  <option value="NSW">NSW – New South Wales</option>
  <option value="VIC">VIC – Victoria</option>
  <option value="QLD">QLD – Queensland</option>
  <option value="WA">WA – Western Australia</option>
  <option value="SA">SA – South Australia</option>
  <option value="TAS">TAS – Tasmania</option>
  <option value="ACT">ACT – Australian Capital Territory</option>
  <option value="NT">NT – Northern Territory</option>
</select>

        <input style={input} placeholder="Postcode" value={postcode} onChange={(e) => setPostcode(e.target.value)} required />

        {/* CLIENT OVERVIEW */}
        <h3 style={sectionHeaderBlue}>Client Overview</h3>
        <select style={input} value={accessType} onChange={(e) => setAccessType(e.target.value)}>
          <option>Access Available Anytime</option>
          <option>Client Must Be Home</option>
          <option>Key / Gate Code Access</option>
        </select>

        <Checkbox label="Street Parking Available" value={streetParking} setValue={setStreetParking} />
        <Checkbox label="Pets at Home" value={petsAtHome} setValue={setPetsAtHome} />
        <Checkbox label="Alarm Code Required" value={alarmCodeRequired} setValue={setAlarmCodeRequired} />

        {/* POOL DETAILS */}
        <h3 style={sectionHeader}>Pool Details</h3>
        <select
  style={input}
  value={poolSize}
  onChange={(e) => setPoolSize(e.target.value)}
  required
>
  <option value="">Pool Service Type</option>
  <option value="Small">Small</option>
  <option value="Medium">Medium</option>
  <option value="Large">Large</option>
</select>

<select
  style={input}
  value={poolType}
  onChange={(e) => setPoolType(e.target.value)}
  required
>
  <option value="">Pool Type</option>
  <option value="Above Ground">Above Ground</option>
  <option value="Inground">Inground</option>
</select>

<select
  style={input}
  value={poolSurface}
  onChange={(e) => setPoolSurface(e.target.value)}
  required
>
  <option value="">Pool Surface</option>
  <option value="Concrete">Concrete</option>
  <option value="Vinyl Liner">Vinyl Liner</option>
  <option value="Fiberglass">Fiberglass</option>
</select>

        <Checkbox label="Has Spa" value={hasSpa} setValue={setHasSpa} />

        {/* CLIENT HISTORY */}
<h3 style={sectionHeader}>Client History</h3>

<label style={checkboxRow}>
  <input
    type="checkbox"
    checked={newClient}
    onChange={(e) => {
      const checked = e.target.checked;
      setNewClient(checked);
      if (checked) setLongTermClient(false);
    }}
  />
  New client (under 6 months)
</label>

<label style={checkboxRow}>
  <input
    type="checkbox"
    checked={longTermClient}
    onChange={(e) => {
      const checked = e.target.checked;
      setLongTermClient(checked);
      if (checked) setNewClient(false);
    }}
  />
  Long-term client (12+ months)
</label>

        {/* SERVICE */}
        <h3 style={sectionHeader}>Service Preferences</h3>
       <select
  style={input}
  value={serviceDay}
  onChange={(e) => setServiceDay(e.target.value)}
>
  <option value="any">Any Day</option>
  <option value="monday">Monday</option>
  <option value="tuesday">Tuesday</option>
  <option value="wednesday">Wednesday</option>
  <option value="thursday">Thursday</option>
  <option value="friday">Friday</option>
  <option value="saturday">Saturday</option>
  <option value="sunday">Sunday</option>
</select>


        <select style={input} value={serviceTime} onChange={(e) => setServiceTime(e.target.value)}>
          <option value="any">Any Time</option>
          <option value="am">Morning</option>
          <option value="pm">Afternoon</option>
        </select>

        <select
  style={input}
  value={frequency}
  onChange={(e) => setFrequency(e.target.value)}
>
  <option value="weekly">Weekly</option>
  <option value="fortnightly">Fortnightly</option>
  <option value="every_3_weeks">Every 3 Weeks</option>
  <option value="monthly">Monthly</option>
</select>


        {/* SERVICES */}
        <h3 style={sectionHeaderPurple}>Pool Services & Chemicals</h3>
        {Object.keys(services).map((key) => (
          <Checkbox
            key={key}
            label={key.replace(/([A-Z])/g, " $1")}
            value={services[key]}
            setValue={() => toggleService(key)}
          />
        ))}

        {/* PRICING */}
        <h3 style={sectionHeaderOrange}>Pricing</h3>
        <input
  style={input}
  placeholder="Price Per Visit ($)"
  value={serviceFee}
  onChange={(e) => setServiceFee(e.target.value)}
/>
<small style={{ color: "#666", marginTop: "-10px" }}>
  The average amount charged for each pool service visit.
</small>

        <input style={input} placeholder="Sale Price ($)" value={salePrice} onChange={(e) => setSalePrice(e.target.value)} required />
{/* DISCLAIMER */}
<div style={{
  marginTop: "20px",
  padding: "15px",
  backgroundColor: "#f9f9f9",
  borderRadius: "8px",
  border: "1px solid #ddd"
}}>
  <label style={{ display: "flex", alignItems: "flex-start", gap: "10px" }}>
    <input
      type="checkbox"
      checked={confirmAccurate}
      onChange={(e) => setConfirmAccurate(e.target.checked)}
      required
      style={{ marginTop: "5px" }}
    />
    <span style={{ fontWeight: "bold" }}>I confirm that:</span>
  </label>

  <ul style={{
    fontSize: "0.9rem",
    color: "#333",
    marginTop: "10px",
    marginLeft: "30px",
    lineHeight: "1.6"
  }}>
    <li>All information provided is accurate and not misleading</li>
    <li>I am solely responsible for this listing</li>
    <li>Client Exchange™ does not verify or guarantee any listing information</li>
    <li>I have authority to transfer this client</li>
    <li>This does not breach any agreement (including franchise or contractual obligations)</li>
    <li>
  I agree to be bound by the Client Exchange™ terms,
  conditions, and policies listed on the website from time to time
</li>
  </ul>

  <p style={{
    fontSize: "0.8rem",
    color: "#666",
    marginTop: "10px"
  }}>
    Listings must comply with any applicable agreements or obligations held by the seller.
  </p>
</div>


        <button
  type="submit"
  style={{
    ...button,
    backgroundColor: confirmAccurate ? "#2e7d32" : "#9e9e9e",
    cursor: confirmAccurate ? "pointer" : "not-allowed",
  }}
  disabled={!confirmAccurate}
>
  Submit Pool Care Listing
</button>

      </form>
    </div>
  );
}

// ================================
// REUSABLE CHECKBOX + STYLES
// ================================
function Checkbox({ label, value, setValue }) {
  return (
    <label style={checkboxRow}>
      <input type="checkbox" checked={!!value} onChange={(e) => setValue(e.target.checked)} />
      {label}
    </label>
  );
}

const container = { maxWidth: "650px", margin: "40px auto", padding: "25px", background: "#fff", borderRadius: "12px" };
const pageHeader = { textAlign: "center", marginBottom: "25px", color: "#2e7d32" };
const form = { display: "flex", flexDirection: "column", gap: "20px" };
const input = { padding: "10px", borderRadius: "6px", border: "1px solid #ccc" };
const checkboxRow = { display: "flex", gap: "10px" };
const sectionHeader = { borderBottom: "2px solid #4CAF50" };
const sectionHeaderBlue = { borderBottom: "2px solid #1976D2" };
const sectionHeaderPurple = { borderBottom: "2px solid #9C27B0" };
const sectionHeaderOrange = { borderBottom: "2px solid #FF9800" };
const button = { padding: "14px", backgroundColor: "#2e7d32", color: "#fff", borderRadius: "8px", border: "none" };

export default PostPoolCareListing;
